export default __webpack_public_path__ + "menu-settlement-icon.180dd83bc0aa604a0005bd83a3f3b37e.svg";